"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = scrollTo;
/**
 * js-utils-apm
 *
 * Copyright © 2016 Appfolio, Inc. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

function scrollTo(x) {
  var leftNavLayout = document.querySelector('.js-left-nav-main #content');

  if (leftNavLayout) {
    leftNavLayout.scrollTop = x;
  } else {
    window.scrollTo(x, 0);
  }
}